import { loadGSAP } from '../../externals/gsap.js';

export const defaults = {
  origin: 'bottom',  // top | bottom | left | right | none
  duration: 0.6,
  delay: 0,
  stagger: 0.1,      // seconds between each child
  distance: 30,      // px
  ease: 'power2.out',
};

export default async function stagger(el, options) {
  await loadGSAP();
  const { gsap } = window;

  const duration    = parseFloat(options.duration);
  const delay       = parseFloat(options.delay);
  const staggerVal  = parseFloat(options.stagger);
  const distance    = parseFloat(options.distance);
  const { origin, ease } = options;

  const children = [...el.children];
  if (!children.length) return;

  const from = { opacity: 0 };
  if (origin === 'bottom') from.y =  distance;
  if (origin === 'top')    from.y = -distance;
  if (origin === 'left')   from.x = -distance;
  if (origin === 'right')  from.x =  distance;

  gsap.from(children, {
    ...from,
    duration,
    delay,
    stagger: staggerVal,
    ease,
  });
}
